

var init = function (element) {

    var modal = element.querySelector('[data-modal-carousel-modal]');
    var modalId = modal ? modal.id : null
    var id = element.dataset.modalCarousel;
    var modalContent = element.querySelector('[data-modal-carousel-modal-content]');
    var carousel = element.querySelector('[data-modal-carousel-carousel]');
    var carouselItems = element.querySelectorAll('[data-modal-carousel-item]');
    var carouselPrev = element.querySelector('[data-modal-carousel-prev]');
    var carouselNext = element.querySelector('[data-modal-carousel-next]');

    // if (modalContent) {
    //     var cloneCarousel = carousel.cloneNode(true);
    //     modalContent.appendChild(cloneCarousel);
    // }

    console.log('mc')


    var modalGlide;

    MicroModal.init({
        openTrigger: 'data-custom-open', // [3]
        closeTrigger: 'data-custom-close', // [4]
        openClass: 'is-open', // [5]
        disableScroll: true, // [6]
        disableFocus: false, // [7]
        awaitOpenAnimation: false, // [8]
        awaitCloseAnimation: false, // [9]
        debugMode: true // [10]
    });

    var pauseVideos = new CustomEvent("pause-video", {});

    carouselItems.forEach((el, index) => {

        // var modal = true; // Can make this a setting?
        if (modal) {
            el.addEventListener('click', function (e) {

                // if (modalGlide) {
                //     modalGlide.update({ startAt: index })
                // }

                MicroModal.show(modalId, {
                    onShow: modal => modalGlide = new Glide('#' + modalId + ' .carousel-modal_container', {
                        startAt: index,
                        type: 'carousel'
                    }).mount(), // [1]
                    onClose: modal => {
                        modalGlide.destroy()
                        modalGlide = null;
                        document.dispatchEvent(pauseVideos);

                    }, // [2]

                });

                if (modalGlide) {
                    modalGlide.on('run', function () {
                        // Handler logic ...
                        document.dispatchEvent(pauseVideos);
                    })
                }
            })
        }

        var cloneEl = el.cloneNode(true);
        cloneEl.classList.add('glide__slide')

        var data = cloneEl.dataset.modalCarouselItem;

        if (data && data.length > 0) {

            var jsonData = JSON.parse(data);


            if (jsonData.imageSizes) {

                var sources = '';
                var backupImg = ''

                for (var i = 0; i < jsonData.imageSizes.length; i++) {
                    var item = jsonData.imageSizes[i];
                    var prevItem = jsonData.imageSizes[i - 1];
                    var nextItem = jsonData.imageSizes[i + 1];
                    var maxWidth = (nextItem) ? `(max-width: ${nextItem.width - 1}px)` : ''
                    var minWidth = (prevItem) ? `(min-width: ${item.width}px)` : ''
                    var comma = (minWidth.length > 0 && maxWidth.length > 0) ? ',' : ''
                    sources += `<source media="${minWidth}${comma}${maxWidth}" srcset="${item.src}">`
                    if (i - 1 === jsonData.imageSizes.length) {
                        backupImg = item.src
                    }
                }

                var html = `
                    <picture>
                        ${sources}
                        <img src="${backupImg}" alt="">
                    </picture>
                `


                cloneEl.innerHTML = html;
            }

            if (jsonData.video) {
                cloneEl.innerHTML = '';
                var videoWrapper = document.createElement("div");
                videoWrapper.className = 'glide__video';
                videoWrapper.dataset.video = jsonData.video;
                cloneEl.appendChild(videoWrapper);
            }

            // cloneEl.className = 'modal-carousel__item';


        }

        if (modal) {
            modalContent.appendChild(cloneEl);
        }

    })

    if (modal) {
        carouselPrev.addEventListener('click', function (e) {
            if (modalGlide) {
                modalGlide.go('<')
            }
        });

        carouselNext.addEventListener('click', function (e) {
            if (modalGlide) {
                modalGlide.go('>')
            }
        });
    }

    if (carousel) {
        var autoplay = carousel.dataset.modalCarouselCarousel && JSON.parse(carousel.dataset.modalCarouselCarousel).autoplay ? 5000 : false;

        var glide = new Glide('#' + id, {
            startAt: 0,
            type: 'carousel',
            autoplay
            // dragThreshold: false,
        }).mount();
    }

    if (modal) {
        var videos = modal.querySelectorAll('[data-video]');
        if (videos) {
            for (var i = 0; i < videos.length; i++) {
                var vid = videos[i];
                window.videolauncher(vid)
            }
        }
    }


}

var carouselElem = document.querySelectorAll('[data-modal-carousel]');

if (carouselElem) {
    for (var i = 0; i < carouselElem.length; i++) {
        var vid = carouselElem[i];
        init(vid)
    }
}